import {
  type Point,
  type Security,
  makeTypeGuardByPropertyValue,
} from '@ipfabric/utils';

export interface RuleChainScope {
  highlightedRuleIndex?: number;
  name: string;
  securityType: Security.SecurityType;
  scrollPosition?: Point;
  type: 'ruleChain';
}

export interface ListingScope {
  /**
   * Show list entities of given type - acl, zone fw or tests in object groups
   *
   * When omitted, we should list entities from all scopes
   */
  entityType?: Security.SecurityType | 'referencedTest';
  type: 'scopeList';
}

export interface ReferencedTestScope {
  name: string;
  type: 'referencedTest';
}

export type SecuritySchemaScope =
  | RuleChainScope
  | ListingScope
  | ReferencedTestScope;

export const isRuleChainScope = makeTypeGuardByPropertyValue<
  SecuritySchemaScope,
  RuleChainScope
>()('type', 'ruleChain');

export const isListingScope = makeTypeGuardByPropertyValue<
  SecuritySchemaScope,
  ListingScope
>()('type', 'scopeList');

export const isReferencedTestScope = makeTypeGuardByPropertyValue<
  SecuritySchemaScope,
  ReferencedTestScope
>()('type', 'referencedTest');
